import React, { Component } from "react";
import styles from "./CareerSearch.scss";
import Job from "./Job";
import Loader from "../../Loader/Loader";


export default class CareerSearchResume extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  componentWillUnmount(){
    this.props.resetToOriginalState();
  }

  componentDidMount() {
    console.log("Original resume_recommendations: ", this.props.resume_recommendations);
  }

  componentDidUpdate(prevProps, prevState){
    if (prevProps.resume_recommendations !== this.props.resume_recommendations) {
      console.log("resume_recommendations changed: ", this.props.resume_recommendations);
    }
  }



  render() {
    if (this.props.resume_recommendations === undefined){
      return (
        <div className={styles.JobsBox}>
          <div className={styles.title}>
          <h5>{"Finding the perfect jobs for you based on your resume..."}</h5>
            <Loader />
          </div>
        </div>
      )
    } else if (this.props.resume_recommendations.length === 0){
      return (
        <div className={styles.JobsBox}>
          <div className={styles.title}>
          <h5>{"No Current Matches."}</h5>
          <p>{"Please search using a different method or come back in the future to see if there are new jobs that match your resume!"}</p>
          </div>
        </div>
      )
    } else {
      return (
        <div className={styles.JobsBox}>
        <div className={styles.title}>
          <h6>{"These results are based on your resume:"}</h6>
        </div>
        <div className={styles.DisplayJobsBox}>
          {this.props.resume_recommendations.map((id) => {
            var job = this.props.jobs.find(job => {
              return job._id === id
            })
            return(
              <Job
                key={job._id}
                job={job}
              />)
          })}
          </div>
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/Careers/CareerSearchResume.js